<template>
  <div>
    <div class="wraper" v-if="!isProjectScenarioLoading">
      <div class="container-fluid mycontainer-fluid">
        <slot name="header"></slot>
        <ProjectHeader></ProjectHeader>
      </div>
      <section class="fpc-content">
        <div class="fpc-container">
          <div class="fpc-content-wrapper">
            <div class="fpc-button-box-container">
              <div class="fpc-button-box">
                <router-link
                  :to="{
                    name: 'ProjectEditStep',
                    params: {
                      id: scenarioProject.ID,
                      step: 'about'
                    }
                  }"
                  class="fpc-back-btn"
                >
                  Вернуться к карточке заявки
                </router-link>
                <a
                  v-if="
                    scenarioProject.SCENARIO.HEAD_BUTTON.IS_VIEW_BUTTON_DOC_ES
                  "
                  class="fpc-back-btn"
                  :href="scenarioProject.SCENARIO.HEAD_BUTTON.CHECK_LIST_LINK"
                  target="_blank"
                >
                  Чек-лист документов
                </a>
                <button
                  v-if="
                    scenarioProject.SCENARIO.HEAD_BUTTON
                      .IS_VIEW_BUTTON_SEND_PROJECT
                  "
                  class="fpc-back-btn"
                  :class="
                    !scenarioProject.SCENARIO.HEAD_BUTTON
                      .IS_ACTIVE_BUTTON_SEND_PROJECT
                      ? 'fpc-back-btn--disabled'
                      : ''
                  "
                  :disabled="
                    !scenarioProject.SCENARIO.HEAD_BUTTON
                      .IS_ACTIVE_BUTTON_SEND_PROJECT
                  "
                  type="button"
                  @click="handleMoveToFund"
                  ref="BUTTON_SEND"
                >
                  направить заявку в фонд
                </button>
              </div>
            </div>
            <div class="fpc-application-status">
              <div class="fpc-block-title">Статус заявки</div>
              <div
                v-if="!!scenarioProject.SCENARIO.STATUS_BAR.TEXT_STATUS_BEFORE"
                class="fpc-block-subtitle"
              >
                <span class="bold">
                  {{ scenarioProject.SCENARIO.STATUS_BAR.TEXT_STATUS_BEFORE }}
                </span>
                <span
                  v-if="!!scenarioProject.SCENARIO.STATUS_BAR.TEXT_HELP_BEFORE"
                >
                  -
                  <span
                    v-html="
                      scenarioProject.SCENARIO.STATUS_BAR.TEXT_HELP_BEFORE
                    "
                  ></span>
                </span>
              </div>
              <div class="fpc-application-status__body">
                <div
                  v-if="
                    scenarioProject.SCENARIO.STATUS_BAR.LIST_STATUS_BAR &&
                      scenarioProject.SCENARIO.STATUS_BAR.LIST_STATUS_BAR
                        .length === 1
                  "
                  class="fpc-application-status__item fpc-application-status__item--big"
                  :class="{
                    'fpc-application-status__item--progress':
                      scenarioProject.SCENARIO.STATUS_BAR.LIST_STATUS_BAR[0]
                        .COLOR_BLOCK === 'blue',
                    'fpc-application-status__item--revision':
                      scenarioProject.SCENARIO.STATUS_BAR.LIST_STATUS_BAR[0]
                        .COLOR_BLOCK === 'red'
                  }"
                  style="min-height: 26px;"
                >
                  <div class="fpc-application-status__item-text">
                    {{
                      scenarioProject.SCENARIO.STATUS_BAR.LIST_STATUS_BAR[0]
                        .TEXT_STATUS
                    }}
                  </div>
                </div>
                <div v-else class="fpc-application-status__items">
                  <div
                    v-for="(item, index) in scenarioProject.SCENARIO.STATUS_BAR
                      .LIST_STATUS_BAR"
                    :key="index"
                    class="fpc-application-status__item"
                    :class="{
                      'fpc-application-status__item--progress':
                        item.COLOR_BLOCK === 'blue',
                      'fpc-application-status__item--revision':
                        item.COLOR_BLOCK === 'red'
                    }"
                  >
                    <div v-if="item.TEXT_STATUS" class="fpc-help-box">
                      <div class="fpc-help-box__top">
                        {{ item.TEXT_STATUS }}
                      </div>
                      <div class="fpc-help-box__body" v-html="item.TEXT_HELP" />
                    </div>
                  </div>
                </div>
                <div
                  v-if="scenarioProject.SCENARIO.STATUS_BAR.TEXT_HELP_AFTER"
                  class="fpc-application-status__body-description"
                  v-html="scenarioProject.SCENARIO.STATUS_BAR.TEXT_HELP_AFTER"
                />
              </div>
            </div>
            <div class="fpc-organization">
              <div
                class="fpc-block-title fpc-block-title--m-bottom0"
                v-if="scenarioProject.SCENARIO.ORG_LIST.IS_BLOCK"
              >
                Организация:
                <span style="font-weight: normal">{{
                  scenarioProject.SCENARIO.ORG_LIST.NAME_SET
                }}</span>
              </div>
              <template v-else>
                <div class="fpc-block-title fpc-block-title--m-bottom0">
                  Организация:
                </div>
                <div class="fpc-select-wrapper">
                  <template v-if="scenarioProject.SCENARIO.ORG_LIST.IS_BLOCK">
                    <span style="font-size: 16px;">{{
                      scenarioProject.SCENARIO.ORG_LIST.NAME_SET
                    }}</span>
                  </template>
                  <template v-else>
                    <div class="fpc-select-chevron-icon"></div>
                    <select
                      name="organization"
                      id="organization"
                      class="fpc-organization-select"
                      v-model="scenarioProject.SCENARIO.ORG_LIST.ID_SET"
                      :disabled="!!scenarioProject.SCENARIO.ORG_LIST.IS_BLOCK"
                      @change="changeOrg()"
                    >
                      <option
                        v-for="org in scenarioProject.SCENARIO.ORG_LIST.LIST"
                        :value="org.ID"
                        :key="org.ID"
                      >
                        {{ org.NAME }}
                      </option>
                    </select>
                  </template>
                </div>
              </template>
            </div>
            <div
              v-if="!!scenarioProject.SCENARIO.IS_VIEW_NOTIFICATION"
              class="fpc-notification-box"
            >
              <router-link
                :to="{
                  name: 'ProjectNotifications',
                  params: { id: $route.params.id }
                }"
                class="fpc-notification-box__title"
                >Уведомление
              </router-link>
              <div
                v-html="scenarioProject.SCENARIO.NOTIFICATION"
                class="fpc-notification-box__description"
              />
            </div>
            <div class="fpc-project">
              <router-link
                v-for="(proj, index) in scenarioProject.SCENARIO.STAGE_PROJECT"
                :key="index"
                :to="proj.LINK"
                class="fpc-project-item"
                :class="{
                  'fpc-not-active': !proj.IS_ACTIVE_BLOCK,
                  'fpc-project-item-big-text':
                    scenarioProject.SCENARIO.IS_SET_BIG_TEXT
                }"
                target="_blank"
                :aria-disabled="!proj.IS_ACTIVE_BLOCK"
              >
                <div class="fpc-item-header">
                  <div class="fpc-item-title">{{ proj.UF_NAME }}</div>
                  <div
                    v-if="!!proj.UF_DESCRIPTION"
                    class="fpc-item-body"
                    :style="
                      proj.IS_SET_DESCRIPTION_STYLE
                        ? proj.DESCRIPTION_STYLE
                        : ''
                    "
                  >
                    {{ proj.UF_DESCRIPTION }}
                  </div>
                  <div
                    v-if="proj.IS_VIEW_ACCEPT_BAR"
                    class="fpc-item-indicators"
                  >
                    <div class="fpc-item-indicators-container">
                      <div
                        v-for="(box, idx) in proj.ACCEPT_BAR"
                        :key="idx"
                        class="fpc-loaded-box"
                      >
                        <div class="fpc-loaded-box__text">
                          {{ box.NAME }} {{ box.FACT_LOAD }}/{{ box.NEED_LOAD }}
                        </div>
                        <div
                          :style="getGradientStyle(box)"
                          class="fpc-loaded-box__status"
                          :class="{
                            'fpc-loaded-box__status--full-load':
                              box.FACT_LOAD === box.NEED_LOAD
                          }"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="fpc-item-bottom"
                  v-if="scenarioProject.SCENARIO.IS_VIEW_STATUS_CARD"
                >
                  <div
                    class="fpc-item-status"
                    :style="{ backgroundColor: proj.STATUS.UF_COLOR }"
                  >
                    {{ proj.STATUS.UF_NAME }}
                  </div>
                  <div class="fpc-item-number">{{ index + 1 }}</div>
                </div>

                <div v-else class="fpc-item-number stl-pa-br">
                  {{ index + 1 }}
                </div>
              </router-link>
            </div>
          </div>
        </div>
      </section>
      <div class="footer footer-fix">
        <div class="container-fluid mycontainer-fluid">
          <div class="myfooter">
            <div class="myfooter-frp"></div>
          </div>
        </div>
      </div>
    </div>
    <ProjectMenu />

    <SendProjectDialog v-if="showSendProjectDialog"></SendProjectDialog>
    <ChangeStatusDialog v-if="showChangeStatusDialog"></ChangeStatusDialog>

    <!-- Вопрос на изменение статуса -->
    <div
      class="modal fade in"
      tabindex="-1"
      v-bind:class="{ show: showDialogChangeStatus }"
      role="dialog"
    >
      <form>
        <div class="modal-dialog modal-new-style" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
              <h4 class="modal-title">Отправка заявки</h4>
            </div>
            <div class="modal-body">
              <div class="form-group">
                <p>
                  Вы действительно хотите отправить заявку?
                </p>
              </div>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="butt-stl butt-black"
                data-dismiss="modal"
                v-on:click="showDialogChangeStatus = false"
              >
                отменить
              </button>
              <button
                type="button"
                @click="sendToStatus(statuses[0].ID)"
                class="butt-stl butt-blue"
              >
                отправить
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </form>
    </div>
    <!-- /.modal -->
    <!-- Удалить заседание -->
  </div>
</template>

<script>
import {
  FETCH_DIRECTORY,
  FETCH_SCENARIO_PROJECT,
  RESEND_PROJECT,
  SAVE_PROJECT,
  SEND_PROJECT
} from "@/store/actions.type";
import { mapGetters } from "vuex";
import FirstScenariosStep from "@/components/project/form/subpartial/FirstScenariosStep.vue";
import ProjectHeader from "@/components/project/partial/ProjectHeader.vue";
import { ProjectsService } from "@/common/api.service";
import ProjectMenu from "@/components/project/partial/ProjectMenu.vue";
import SendProjectDialog from "@/components/project/form/SendProjectDialog";
import ChangeStatusDialog from "@/components/project/form/ChangeStatusDialog";

export default {
  name: "ScenarioRequest",
  title: "Подача заявки",
  components: {
    ProjectMenu,
    ProjectHeader,
    FirstScenariosStep,
    SendProjectDialog,
    ChangeStatusDialog
  },
  data() {
    return {
      tosterErrors: [],
      showSendProjectDialog: false,
      showChangeStatusDialog: false,
      showDialogChangeStatus: false,
      saveErrorFields: {},
      projectErrors: {},
      budgetErrors: {},
      mainCoverErrors: {},
      contactErrors: {},
      subContractErrors: {},
      planBuyersProductsErrors: {},
      digitalSolutionsErrors: {},
      bankGuarantErrors: {},
      budgetLizingErrors: {},
      otherSourceFinanceErrors: {},
      systemEquipmentErrors: {},
      systemIntegratorErrors: {},
      legalEntitiesErrors: {},
      zalogErrors: {},
      indicatorsErrors: {},
      providingMobilizationNeeds: {},
      statuses: []
    };
  },
  async mounted() {
    await Promise.all([
      this.$store.dispatch(FETCH_DIRECTORY, ["status"]),
      this.$store.dispatch(FETCH_DIRECTORY, ["status_all"]),
      this.$store.dispatch(FETCH_DIRECTORY, ["program_fin_support"])
    ]);

    await this.fetchProject();
  },
  computed: {
    projectStatusCode: function() {
      if (this.scenarioProject.UF_STATUS_ID > 0) {
        let t = this.directory.status.filter(
          c => c.ID === this.scenarioProject.UF_STATUS_ID
        );
        if (t.length > 0) {
          return t[0].CODE;
        }
      }
    },
    ...mapGetters([
      "scenarioProject",
      "isProjectScenarioLoading",
      "saveProjectErrors",
      "saveProjectSaved",
      "showTotalMessageSaved",
      "directory",
      "currentUser"
    ])
  },
  methods: {
    getGradientStyle(box) {
      const loadPercentage =
        box.NEED_LOAD > 0 ? (box.FACT_LOAD / box.NEED_LOAD) * 100 : 0;
      return {
        background: `linear-gradient(90deg, #3068BD ${loadPercentage}%, transparent ${loadPercentage}%)`
      };
    },

    async handleMoveToFund() {
      if (this.scenarioProject.SCENARIO.HEAD_BUTTON.ACTION === "sendProject") {
        await this.prepareToSendProject();
      }
      if (
        this.scenarioProject.SCENARIO.HEAD_BUTTON.ACTION ===
        "changeStatusProject"
      ) {
        //await this.sendToStatus();
        await this.prepareToChangeStatusProject();
      }
    },

    sendToStatus(id) {
      ProjectsService.setNewStatusProject(this.scenarioProject.ID, {
        UF_STATUS_ID: id
      }).then(response => {
        this.showDialogChangeStatus = false;

        if (response.data.error === false) {
          this.fetchProject();
          this.$router.push({ name: "Projects" });
          this.$toasted.show("Заявка успешно отправлена", {
            theme: "green",
            position: "bottom-right",
            duration: 3500
          });
        } else {
          response.data.errorArr.forEach(function(text) {
            this.$toasted.show(text, {
              theme: "red",
              position: "bottom-right",
              duration: 3500
            });
          }, this);
        }
      }, this);
    },

    async prepareToSendProject() {
      if (this.projectStatusCode === "draft") {
        this.showSendProjectDialog = true;
      } else if (this.projectStatusCode === "express_grades_revision") {
        this.reSendProject();
      }
      /*this.tosterErrors.forEach(function(err) {
        err.goAway(0);
      });
      const s = await this.saveProject();
      if (s) {
        if (this.tosterErrors.length === 0) {
          if (this.projectStatusCode === "draft") {
            this.showSendProjectDialog = true;
          } else if (this.projectStatusCode === "express_grades_revision") {
            this.reSendProject();
          }
        }
      }*/
    },

    async prepareToChangeStatusProject() {
      this.showDialogChangeStatus = true;
    },

    async saveProject() {
      this.tosterErrors.forEach(function(err) {
        err.goAway(0);
      });
      this.tosterErrors = [];
      this.saveErrorFields = {};
      this.projectErrors = {};
      this.budgetErrors = {};
      this.mainCoverErrors = {};
      this.contactErrors = {};
      this.subContractErrors = {};
      this.planBuyersProductsErrors = {};
      this.digitalSolutionsErrors = {};
      this.bankGuarantErrors = {};
      this.budgetLizingErrors = {};
      this.otherSourceFinanceErrors = {};
      this.systemEquipmentErrors = {};
      this.systemIntegratorErrors = {};
      this.legalEntitiesErrors = {};
      this.zalogErrors = {};
      this.indicatorsErrors = {};
      this.providingMobilizationNeeds = {};
      const s = await this.$store
        .dispatch(SAVE_PROJECT, this.project)
        .then(() => {
          if (this.saveProjectSaved) {
            this.fetchProject(this.step);
          }
          if (this.saveProjectErrors.length > 0) {
            this.saveProjectErrors.forEach(function(err) {
              if (err.MODEL === "BUDGET") {
                this.addBudgetError(err);
              }
              if (err.MODEL === "MAIN_COVER") {
                this.addMainCoverError(err);
              }
              if (err.MODEL === "CONTACTS") {
                this.addContactError(err);
              }
              if (err.MODEL === "PROVIDING_MOBILIZATION_NEEDS") {
                this.addProvidingMobilizationError(err);
              }
              if (err.MODEL === "SUBCONTRACTORS") {
                this.addSubContractError(err);
              }
              if (err.MODEL === "PLAN_BUYERS_PRODUCTS") {
                this.addPlanBuyersProductsError(err);
              }
              if (err.MODEL === "DIGITAL_SOLUTION") {
                this.addDigitalSolutionsError(err);
              }
              if (err.MODEL === "BANK_GUARANTEE") {
                this.addBankGuarantError(err);
              }
              if (err.MODEL === "BUDGET_LIZING") {
                this.addBudgetLizingError(err);
              }
              if (err.MODEL === "OTHER_SOURCE_FINANCE") {
                this.addOtherSourceFinanceError(err);
              }
              if (err.MODEL === "INDICATORS") {
                this.addIndicatorError(err);
              }
              if (err.MODEL === "PURCHASED_EQUIPMENT") {
                this.addSystemEquipmentError(err);
              }
              if (err.MODEL === "SYSTEM_INTEGRATOR") {
                this.addSystemIntegratorError(err);
              }
              if (err.MODEL === "LEGAL_ENTITIES") {
                this.addLegalEntitiesError(err);
              }
              if (err.MODEL === "ZALOG") {
                this.addZalogError(err);
              }
              if (typeof err.TYPE === "undefined") {
                err.TYPE = "LOGIC";
              }
              if (typeof this.saveErrorFields[err.MODEL] === "undefined") {
                this.saveErrorFields[err.MODEL] = {};
              }
              if (
                typeof this.saveErrorFields[err.MODEL][err.TYPE] === "undefined"
              ) {
                this.saveErrorFields[err.MODEL][err.TYPE] = {};
              }
              this.saveErrorFields[err.MODEL][err.TYPE][err.FIELDS] = err.TEXT;
              this.tosterErrors[this.tosterErrors.length] = this.$toasted.show(
                err.TEXT,
                {
                  theme: "bubble",
                  position: "bottom-right",
                  duration: null,
                  action: [
                    {
                      text: "Закрыть",
                      onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                      }
                    },
                    {
                      text: "Закрыть все",
                      onClick: () => {
                        this.tosterErrors.forEach(function(err) {
                          err.goAway(0);
                        });
                      }
                    }
                  ]
                }
              );
            }, this);

            if (this.showTotalMessageSaved) {
              this.tosterErrors[this.tosterErrors.length] = this.$toasted.show(
                this.getStatus(this.scenarioProject.UF_STATUS_ID).CODE ===
                  "draft"
                  ? "Проект сохранен, но для отправки проекта для проверки в ФРП, необходимо устранить указанные ошибки"
                  : this.saveProjectSaved && this.saveProjectErrors
                  ? "Изменения сохранены. Пожалуйста, устраните замечания во избежании дальнейших ошибок"
                  : "Изменения не сохранены. Пожалуйста, устраните замечания для сохранения резюме",
                {
                  theme: "red",
                  position: "bottom-right",
                  duration: null,
                  action: [
                    {
                      text: "Закрыть",
                      onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                      }
                    },
                    {
                      text: "Закрыть все",
                      onClick: () => {
                        this.tosterErrors.forEach(function(err) {
                          err.goAway(0);
                        });
                      }
                    }
                  ]
                }
              );
            }

            this.rerender = false;
            this.rerender = true;
            return false;
          } else if (this.saveProjectSaved) {
            this.$toasted.show("Проект успешно сохранен", {
              theme: "green",
              position: "bottom-right",
              duration: 3500
            });
          }
          return true;
        });
      return s;
    },

    sendProject() {
      this.$store.dispatch(SEND_PROJECT, this.project).then(() => {
        this.showSendProjectDialog = false;
        this.fetchProject(this.step);

        this.$toasted.show("Заявка успешно отправлена", {
          theme: "green",
          position: "bottom-right",
          duration: 3500
        });
      }, this);
    },

    reSendProject() {
      this.$store.dispatch(RESEND_PROJECT, this.project).then(() => {
        this.showSendProjectDialog = false;
        this.fetchProject(this.step);
      }, this);
    },

    async fetchProject() {
      try {
        await this.$store.dispatch(
          FETCH_SCENARIO_PROJECT,
          this.$route.params.id
        );

        if (!this.scenarioProject.UF_STATUS_ID) {
          console.warn("Scenario project data is not available");
          return;
        }

        this.project = this.scenarioProject;

        const { data } = await ProjectsService.getRulesChangeStatusUser(
          this.scenarioProject.UF_STATUS_ID
        );

        if (data.IS_CHANGE_STATUS) {
          this.directory.program_fin_support.forEach(async function(s) {
            this.showSubmitBtn = false;
            if (s.ID === this.scenarioProject.UF_SUPPORT_PROG_ID) {
              this.statuses = [];
              const bpStatusData = await ProjectsService.bpStatus(
                s.UF_BP_ID,
                this.scenarioProject.UF_STATUS_ID
              );

              Object.keys(bpStatusData.data[0].PREV_STATUS_ID).forEach(function(
                k
              ) {
                this.directory.status.forEach(function(item) {
                  if (
                    item.ID === bpStatusData.data[0].PREV_STATUS_ID[k] &&
                    bpStatusData.data[0].PREV_STATUS_ID[k] !== 458323
                  ) {
                    this.statuses.push(item);
                  }
                }, this);
              },
              this);

              Object.keys(bpStatusData.data[0].NEXT_STATUS_ID).forEach(function(
                k
              ) {
                this.directory.status.forEach(function(item) {
                  if (
                    item.ID === bpStatusData.data[0].NEXT_STATUS_ID[k] &&
                    bpStatusData.data[0].PREV_STATUS_ID[k] !== 458323
                  ) {
                    this.statuses.push(item);
                  }
                }, this);
              },
              this);
            }
          }, this);
        }
      } catch (error) {
        console.error("Error fetching scenario project:", error);
      }
    },

    moveBack() {
      this.$router.push({
        name: "ProjectEditStep",
        params: {
          id: this.$route.params.id,
          step: "about"
        }
      });
    },

    moveToDocs() {
      this.$router.push({
        name: "ProjectDocuments",
        params: {
          id: this.$route.params.id
        }
      });
    },

    changeOrg() {
      let code = this.scenarioProject.SCENARIO.ORG_LIST.LIST.filter(function(
        el
      ) {
        if (el.ID === this.scenarioProject.SCENARIO.ORG_LIST.ID_SET) {
          return true;
        }
        return false;
      },
      this);

      ProjectsService.getScenarioProjectBlock(this.scenarioProject.ID, {
        ID_SET: this.scenarioProject.SCENARIO.ORG_LIST.ID_SET,
        CODE_SET: code[0].TYPE
      }).then(({ data }) => {
        console.log(data);
        if (data.length) {
          this.scenarioProject.SCENARIO.STAGE_PROJECT = data;
        }
      }, this);
    }
  }
};
</script>

<style scoped></style>
